import { render, staticRenderFns } from "./support-ticket.vue?vue&type=template&id=0bc015c8"
import script from "./support-ticket.vue?vue&type=script&lang=js"
export * from "./support-ticket.vue?vue&type=script&lang=js"
import style0 from "./support-ticket.vue?vue&type=style&index=0&id=0bc015c8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports